export const escapeODataString = (value: string) => value.trim().replace(/'/g, "''");

export const createOrderBy = (
    field: string,
    direction: string,
    allowedFields: readonly string[],
    fallbackField = 'number',
) => {
    const safeField = allowedFields.includes(field) ? field : fallbackField;
    const safeDirection = direction.toLowerCase() === 'asc' ? 'asc' : 'desc';
    return `${safeField} ${safeDirection}`;
};
